import { render, staticRenderFns } from "./SetariAliaje.vue?vue&type=template&id=375fa8d3"
import script from "./SetariAliaje.vue?vue&type=script&lang=js"
export * from "./SetariAliaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports